module.exports = __webpack_public_path__ + "img/star.2b1c5b85.svg";